var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{staticClass:"asset-details",attrs:{"guttered":false,"title":_vm.$it('global.image', 'Image')}},[_c('img',{attrs:{"src":_vm.asset.lastInspection.firstImage.thumbUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }